import Intercom, { update } from "@intercom/messenger-js-sdk";

const intercomPlugin = defineNuxtPlugin((nuxtApp) => {
  const { isSportbenefitBrand, intercom: { appId } } = useRuntimeConfig().public;

  if (!isSportbenefitBrand || !appId) {
    return;
  }
  
  Intercom({
    app_id: appId
  });

  nuxtApp.hook("page:finish", () => {
    update({});
  });
});

export default intercomPlugin;